import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMenu,FiX,FiClock}=FiIcons;

const Header=({timeLeft,openCheckoutPopup})=> {
  const [isMenuOpen,setIsMenuOpen]=useState(false);

  const formatTime=(seconds)=> {
    const mins=Math.floor(seconds / 60);
    const secs=seconds % 60;
    return `${mins.toString().padStart(2,'0')}:${secs.toString().padStart(2,'0')}`;
  };

  const scrollToSection=(id)=> {
    document.getElementById(id)?.scrollIntoView({behavior: 'smooth'});
    setIsMenuOpen(false);
  };

  return (
    <>
      <motion.header 
        className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md border-b border-purple-100 z-50"
        initial={{y: -100}}
        animate={{y: 0}}
        transition={{duration: 0.5}}
      >
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-purple-600 to-orange-400 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">🪔</span>
              </div>
              <span className="font-bold text-xl text-gray-800">YinGuru</span>
            </div>
            
            <nav className="hidden md:flex items-center space-x-8">
              <button onClick={()=> scrollToSection('about')} className="text-gray-600 hover:text-purple-600 transition-colors">
                What You'll Learn
              </button>
              <button onClick={()=> scrollToSection('bonuses')} className="text-gray-600 hover:text-purple-600 transition-colors">
                Bonuses
              </button>
              <button onClick={()=> scrollToSection('testimonials')} className="text-gray-600 hover:text-purple-600 transition-colors">
                Testimonials
              </button>
              <button onClick={()=> scrollToSection('faq')} className="text-gray-600 hover:text-purple-600 transition-colors">
                FAQs
              </button>
              <button onClick={openCheckoutPopup} className="glow-button text-white px-6 py-2 rounded-xl font-semibold">
                Buy Now
              </button>
            </nav>
            
            <button className="md:hidden p-2" onClick={()=> setIsMenuOpen(!isMenuOpen)}>
              <SafeIcon icon={isMenuOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <motion.div 
            className="md:hidden bg-white border-t border-purple-100"
            initial={{opacity: 0, height: 0}}
            animate={{opacity: 1, height: 'auto'}}
            exit={{opacity: 0, height: 0}}
          >
            <div className="container mx-auto px-4 py-4 space-y-4">
              <button onClick={()=> scrollToSection('about')} className="block w-full text-left text-gray-600 hover:text-purple-600">
                What You'll Learn
              </button>
              <button onClick={()=> scrollToSection('bonuses')} className="block w-full text-left text-gray-600 hover:text-purple-600">
                Bonuses
              </button>
              <button onClick={()=> scrollToSection('testimonials')} className="block w-full text-left text-gray-600 hover:text-purple-600">
                Testimonials
              </button>
              <button onClick={()=> scrollToSection('faq')} className="block w-full text-left text-gray-600 hover:text-purple-600">
                FAQs
              </button>
              <button onClick={openCheckoutPopup} className="glow-button text-white px-6 py-3 rounded-xl font-semibold w-full">
                Buy Now
              </button>
            </div>
          </motion.div>
        )}
      </motion.header>

      {/* Sticky CTA Button */}
      <motion.button 
        className="sticky-cta glow-button text-white px-6 py-3 rounded-xl font-semibold shadow-lg flex items-center space-x-2"
        onClick={openCheckoutPopup}
        initial={{scale: 0}}
        animate={{scale: 1}}
        transition={{delay: 2, duration: 0.5}}
      >
        <span>💥</span>
        <span className="hidden sm:inline">Get the eBook for ₹97</span>
        <span className="sm:hidden">₹97 Only</span>
        <span>→</span>
      </motion.button>
    </>
  );
};

export default Header;